import type * as core from '../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.universal.orgStructure.withoutDivisions',
    'resource:data.dimensions.organization.entities.division',
  ],
  description: 'TODO',
  name: 'Org Structure - With Divisions',
} as const satisfies core.quiver.Package
